 <template>
  <div id="thank-screen">
    <lottie-player
      src="/static/images/kudos/thank-you.json"
      background="transparent"
      speed="0.5"
      loop
      style="width: 300px; height: 300px"
      autoplay
    ></lottie-player>
    <div class="notification-text">
      {{ $t('thankScreen.notificationText') }}
    </div>
    <div class="join-text">
      {{ $t('thankScreen.joinText') }}
      <div class="button-wrapper">
        <a class="button" href="https://get.motivac.io?src=thank">
          <span>READ MORE!</span>
        </a>
      </div>
    </div>
    <img class="logo" src="/static/images/logo_full.png" alt="" />
  </div>
</template>
 
 <script>
 import { mapActions } from 'vuex';
export default {
  name: 'ThankScreen',
  created() {
    this.thank(this.$route.params.code)
  },
  methods: {
    ...mapActions({
      thank: 'kudos/thank'
    })
  }
};
</script>
 
 <style lang="scss" scoped>
#thank-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e1f1ff;
  min-height: 100vh;
  flex-direction: column;
  .notification-text {
    font-size: 1.2rem;
    font-weight: bold;
    max-width: 300px;
    text-transform: uppercase;
  }
  .join-text {
    font-size: 0.8rem;
    margin: 40px 0;
    max-width: 400px;
  }
  .logo {
    max-height: 30px;
    margin: 30px 0;
  }
  .button-wrapper {
    margin: 20px 0;
    .button {
      background: linear-gradient(90deg, #3381c3 0%, #622d90 100%);
      border-radius: 30px;
      -webkit-box-shadow: 0 4px 10px rgb(0 0 0 / 25%);
      -moz-box-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
      box-shadow: 0 4px 10px rgb(0 0 0 / 25%);
      display: inline-block;
      position: relative;
      text-decoration: none;
      height: 40px;
      span {
        color: #fff;
        display: block;
        font-size: 20px;
        height: 100%;
        line-height: 1;
        padding: 10px 30px;
        position: relative;
        width: 100%;
        z-index: 1;
      }
    }
  }
}
</style>